import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import classes from "./UserLandingPage.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Button, TextField } from "@mui/material";
import AssessmentCard from "./AssessmentCard";
import CourseCard from "./CourseCard";

const Courses = ({
  allCourses,
  courseType,
  activeCourseTab,
  setActiveCourseTab,
  handleRedirect,
}) => {
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setActiveCourseTab(tab);
  };

  return (
    <>
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between">
            <div className={classes.assessmentsHeader}>Courses</div>
            {/* <div className={classes.arrowContainer}>
              <div className={classes.leftArrow}>
                <ArrowBackIosIcon />
              </div>
              <div className={classes.rightArrow}>
                <ArrowForwardIosIcon />
              </div>
            </div> */}
          </div>
          {/* <div className="mt-2">
            <TextField
              placeholder="Search Courses"
              inputProps={{
                style: { height: "10px" },
              }}
            />
          </div> */}
          <div className={classes.courseParticipantsTabCon}>
            <Button
              className="transparent"
              onClick={() => {
                handleTabClick(1);
              }}
              sx={{ background: activeTab === 1 ? "#FFFFFF" : "" }}
            >
              In Progress
            </Button>
            <Button
              className="transparent"
              onClick={() => {
                handleTabClick(2);
              }}
              sx={{ background: activeTab === 2 ? "#FFFFFF" : "" }}
            >
              Completed
            </Button>
            <Button
              className="transparent"
              sx={{ background: activeTab === 3 ? "#FFFFFF" : "" }}
              onClick={() => {
                handleTabClick(3);
              }}
            >
              Upcoming
            </Button>
          </div>

          <Row className="mt-5 ">
            {allCourses?.length > 0 ? (
              allCourses.map((course, index) => {
                return (
                  <>
                    <Col xl={3} lg={3} md={12} sm={12} className=" w-50 mt-3">
                      <CourseCard
                        course={course}
                        key={index}
                        handleRedirect={handleRedirect}
                        courseType={courseType}
                      />
                    </Col>
                  </>
                );
              })
            ) : (
              <>
                <div>No Courses Found</div>
              </>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default Courses;
